export default "__VITE_ASSET__255568a6__"